import React from 'react';
import './LevelComparison.css';
import Api from '../services/api';
import AuthService from '../services/auth';
import { map } from 'lodash';
import check from '../static/vectors/check.svg';
import USER_STATUSES from '../constants/userStatuses';

class LevelComparison extends React.Component {

  constructor(props) {
    super(props);
    this.state={
      levels: [],
      caps: {},
    }
  }

  componentDidMount() {
    const { levels } = this.props;

    (new Api()).get('/access-levels', { levels }, AuthService.getAuthCookie())
      .then(response => {
        let allCaps = {};
        let levels = [];
        response.map(el => {
          levels.push(el);
          el.capabilities.map(cap => {
            allCaps[cap.cap] = cap.label;
            return cap;
          });
          el.capabilities = map(el.capabilities, 'cap');
          return el;
        });
        this.setState({
          caps: allCaps,
          levels,
        })
      });
  }

  render() {
    const { levels, caps } = this.state;
    const { title } = this.props;
    if(levels.length > 0 && Object.keys(caps).length > 0) {
      return (
        <div className="level-comparison">
          <div className="title">{title}</div>
          <div className="header-row row">
            <div className="cap col col-12 col-sm">Capability</div>
            {levels.map(el =>
              <div key={el.key} className={`level-name col col-12 col-sm-4 col-md-3 ${(el.statusCode === USER_STATUSES.approved) ? 'd-none d-md-block' : ''}`}>{el.name}</div>
            )}
          </div>
          {Object.keys(caps).map(cap => (
            <div key={cap} className="cap-row row">
              <div className="cap col col-12 col-sm">{caps[cap]}</div>
              {levels.map(el => (
                <div key={Math.random()} className={`level-name col col-12 col-sm-4 col-md-3 ${(el.statusCode === USER_STATUSES.approved) ? 'd-none d-md-block' : ''}`}>{(el.capabilities.includes(cap))?<img src={check} alt="check" />:''}</div>
              ))}
            </div>
          ))}
          <div className="cap-row row">
            <div className="cap col">
              Magnets
            </div>
            {levels.map(el => (
              <div key={Math.random()} className={`level-name col col-12 col-sm-4 col-md-3 ${(el.statusCode === USER_STATUSES.approved) ? 'd-none d-md-block' : ''}`}>(extra fee)</div>
            ))}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

}

export default LevelComparison;


// WEBPACK FOOTER //
// ./src/components/LevelComparison.js